<template>
  <database-management-modal :element="region" ref="modal">
    <template v-slot:body>
      <div :class="hasErrorClass($v.region.admin_email, 'form-group')">
        <label class="control-label">* Admin email</label><br>
        <i>Add multiple email addresses in here to keep other stakeholders notified of any requests, separated by ','</i>
        <input
          name="admin_email"
          type="email"
          class="form-control"
          v-model="$v.region.admin_email.$model" />

        <vuelidate-help :field="$v.region.admin_email" label="Admin email" />
      </div>
      <div :class="hasErrorClass($v.region.from_email, 'form-group')">
        <label class="control-label">* From email</label><br>
        <i>From email address that will display to the recipient</i>
        <input
          name="from_email"
          type="email"
          class="form-control"
          v-model="$v.region.from_email.$model" />

        <vuelidate-help :field="$v.region.from_email" label="From email" />
      </div>
    </template>
    <template v-slot:footer>
      <ladda-button :click="saveRegion" type="button" class="btn btn-lg btn-primary pull-right" data-dismiss="modal"><i class="fa fa-check"></i> Save</ladda-button>
    </template>
  </database-management-modal>
</template>

<script>
import { required, email } from 'vuelidate/lib/validators'
import VuelidateHelp from '../../misc/VuelidateHelp'
import Selectize from '../../ext/codium/CodiumSelectize'
import { http, notify } from 'utils'
import DatabaseManagementModal from './templates/DatabaseManagementModal'
export default {
  components: {DatabaseManagementModal, VuelidateHelp, Selectize},

  props: {
    region: {
      required: true
    }
  },

  watch: {
    'region' (newValue, oldValue) {
      if (newValue.admin_email !== null) {
        this.region.admin_email = newValue.admin_email.includes('[') ? JSON.parse(newValue.admin_email).toString() : newValue.admin_email
      }
    }
  },

  methods: {
    hasErrorClass (field, classes) {
      return field.$error ? `${classes} has-error` : `${classes}`
    },

    closeModal () {
      this.$refs.modal.closeModal()
    },

    saveRegion () {
      if (this.$v.$invalid) {
        this.$v.$touch()
        notify.error(`Some fields failed validation. Please fix them and try again`)
        return Promise.reject(new Error('Data invalid'))
      }

      this.region.admin_email = JSON.stringify(this.region.admin_email.split(','))

      return http.put(`region/${this.region.id}/update`, this.region).then((response) => {
        this.$emit('update', response.data)
        this.closeModal()
      })
    }
  },

  validations () {
    return {
      region: {
        admin_email: {
          required,
          multipleEmails (entry) {
            if (!entry) {
              return false
            }
            const entries = entry.split(',')
            for (let i = 0; i < entries.length; i++) {
              if (!email(entries[i].trim())) {
                return false
              }
            }
            return true
          }
        },
        from_email: {
          required,
          email
        }
      }
    }
  }
}
</script>
